
exports.getCookie = (c_name) => {
    let name = c_name + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length);
        }
    }
    return "";
};

exports.setCookie = (c_name, c_value, c_minutes) => {
    let expires = "";
    if(c_minutes){
        let d = new Date();
        d.setTime(d.getTime() + (c_minutes * 60 * 1000));
        expires = "expires=" + d.toUTCString() + ";";
    }
    document.cookie = c_name + "=" + c_value + ";" + expires + "path=/";
};

exports.delCookie = (c_name) => {
    exports.setCookie(c_name,'',-1);
};



// WEBPACK FOOTER //
// ./src/utils/cookie.js